import { PageRouteProps } from "../../types";

export const blogRoutes: PageRouteProps[] = [
  {
    pathName: "/blog",
    module: ["Blog"],
    component: "Blog",
    type: "public",
    mode: "static",
  },
  {
    pathName: "/post",
    module: ["Blog"],
    component: "Post",
    type: "public",
    mode: "dynamic",
  },
];
